import {
  EM_DASH,
  WITHHELD_LABEL,
  WITHHELD_TOOLTIP,
  darReasonTooltip,
} from '../core/copy';
import type { FieldPresentationState } from '../resolvers/field-state';

/**
 * The single UI switch over an absent field's presentation state. Minimal
 * markup for now — tooltip/icon treatment upgrades with @eluve/components.
 */
export function FieldStateMarker({
  state,
}: {
  state: Exclude<FieldPresentationState, { kind: 'present' }>;
}) {
  switch (state.kind) {
    case 'not-recorded':
      return <span className="text-muted-foreground">{EM_DASH}</span>;
    case 'benign-dar':
      return (
        <span
          className="text-muted-foreground underline decoration-dotted"
          title={darReasonTooltip(state.reason)}
        >
          {EM_DASH}
        </span>
      );
    case 'withheld':
      return (
        <span
          className="text-muted-foreground"
          title={WITHHELD_TOOLTIP[state.mechanism]}
          data-fhir-withheld={state.mechanism}
        >
          {WITHHELD_LABEL}
        </span>
      );
  }
}
